import axios from 'axios';

import AppConfig from '../config/AppConfig';
import AuthService from '../services/AuthService';
import { getStorage } from '../helpers/Storage';

const baseUrl = AppConfig.get('API_BASE_URL_MP_BEM_VINDO');
const apiKey = AppConfig.get('REACT_APP_API_KEY');
const localApiKey = '7ae09b28e822446cacad01fc5e5f41a8';

const instance = axios.create({
  baseURL: baseUrl,
});

instance.interceptors.request.use(function (config) {
  const token = getStorage('token');
  const localEnv = globalThis.location.href.includes('localhost');

  if (!!token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers.apikey = localEnv ? localApiKey : apiKey;

  return config;
});

instance.interceptors.response.use(
  function (config) {
    return config;
  },
  function (error) {
    const isApplicationStatusCheck = error?.config?.url?.includes('configuration/freezing');

    if (error?.response?.status === 401 && !isApplicationStatusCheck) {
      AuthService.userNotAllowed();
    }

    return Promise.reject(error);
  }
);

export default instance;
